'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var dynamicList = function dynamicList() {
  return import('@/page/dynamic/dynamic-list');
};
var dynamicDetail = function dynamicDetail() {
  return import('@/page/dynamic/dynamic-detail');
};

exports.default = [{
  path: '/dynamicList',
  name: 'dynamicList',
  component: dynamicList
}, {
  path: '/dynamicDetail',
  name: 'dynamicDetail',
  component: dynamicDetail
}];